module.exports = __webpack_public_path__ + "img/maisonDeSante_visuel.59402a49.svg";